import React from 'react';
import { Monitor, Moon, Sun } from 'lucide-react';
import { setTema, useTema } from '../lib/tema';

/**
 * Conmutador Sol/Monitor/Luna — port del ConmutadorTema de la landing oficial.
 * `sobreHero` lo estila para flotar sobre el vídeo del héroe (bordes/tinta en
 * blanco), igual que el resto de controles del header en ese estado.
 */
const OPCIONES = [
  { id: 'claro', Icono: Sun, etiqueta: 'Tema claro' },
  { id: 'sistema', Icono: Monitor, etiqueta: 'Tema del sistema' },
  { id: 'oscuro', Icono: Moon, etiqueta: 'Tema oscuro' },
];

export const ThemeToggle = ({ sobreHero = false, sinBorde = false }) => {
  const { tema } = useTema();
  return (
    <div
      className={`flex rounded-md border p-0.5 ${
        sobreHero ? 'border-white/25 bg-white/5' : sinBorde ? 'border-transparent' : 'border-border'
      }`}
      role="group"
      aria-label="Tema de color"
    >
      {OPCIONES.map(({ id, Icono, etiqueta }) => (
        <button
          key={id}
          type="button"
          title={etiqueta}
          aria-label={etiqueta}
          aria-pressed={tema === id}
          onClick={() => setTema(id)}
          className={`rounded-sm p-1.5 transition-colors ${
            tema === id
              ? sobreHero
                ? 'bg-white/15 text-white'
                : 'bg-muted text-foreground'
              : sobreHero
                ? 'text-white/60 hover:text-white'
                : 'text-[oklch(var(--ink-faint))] hover:text-foreground'
          }`}
        >
          <Icono className="w-3.5 h-3.5" aria-hidden="true" />
        </button>
      ))}
    </div>
  );
};

export default ThemeToggle;
